<section class="dashboard-home">
  <div class="dashboard-home__header">
    <h1>Bourne Bespoke Admin</h1>
    <p>Welcome to your admin dashboard.</p>
  </div>

  <div class="dashboard-home__grid">
    <div class="dashboard-card">
      <h2>Projects</h2>
      <p>Manage creations and featured work.</p>
    </div>

    <div class="dashboard-card">
      <h2>Enquiries</h2>
      <p>View contact submissions and follow-ups.</p>
    </div>

    <div class="dashboard-card">
      <h2>Settings</h2>
      <p>Update platform and admin preferences.</p>
    </div>
  </div>
</section>
